import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { RouterLink } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const DVRBackLink = ({ homeLink, activeLink }) => (
  <div className={cx('component')}>
    {homeLink.page === activeLink.page ? (
      <span className={cx('homeTitle')}>
        {homeLink.title}
      </span>
    ) : (
      <RouterLink
        className={['link--hidden-visited-color', cx('backLink')]}
        to={homeLink.path}
      >
        Вернуться в профиль
      </RouterLink>
    )}
  </div>
);

DVRBackLink.propTypes = {
  homeLink: PropTypes.object,
  activeLink: PropTypes.object,
};

export default DVRBackLink;
